// Pricing migration 32 (ADO-3985), T15: "Show me ↓" on the order review's incomplete multi-buy flag
// (19): scroll to the deal's nudge, highlight it with the focus ring for about 1.5s and move focus
// to it (the Cart Drawer Row note: "highlights it with Focus for about 1.5s and moves keyboard
// focus to it"). Smooth, or a jump under reduced motion (the Offer Strip note).

import { prefersReducedMotion } from '../design-system';
import { DEAL_HIGHLIGHT_HOLD_MS } from '../app/ProductDetail/useDealSectionReveal';

/** The element highlighted now and the timer that clears it: one at a time, so revealing another
 *  clears the first at once rather than leaving it on. */
let highlighted: {
  readonly element: HTMLElement;
  readonly timer: ReturnType<typeof setTimeout>;
} | null = null;

export function revealDealElement(element: HTMLElement | null): void {
  if (element === null) return;
  element.scrollIntoView({ block: 'start', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  element.focus({ preventScroll: true });
  if (highlighted !== null) {
    clearTimeout(highlighted.timer);
    delete highlighted.element.dataset['highlight'];
  }
  element.dataset['highlight'] = 'on';
  highlighted = {
    element,
    timer: setTimeout(() => {
      delete element.dataset['highlight'];
      highlighted = null;
    }, DEAL_HIGHLIGHT_HOLD_MS),
  };
}
